module.exports = __webpack_public_path__ + "static/media/Grandpa-Logo.ee7e9234.png";